import React from 'react';
import { FiltersContainer } from '../../FiltersContainer';

export const CountrysideFiltersContainer = () => {
  return <FiltersContainer />;
};
